import * as S from './style.DeviceShippingStatus';

const DeviceShippingStatus = () => {
    return (
        <S.Container>

        </S.Container>
    )
}

export default DeviceShippingStatus;
